export default function (vm) {
  var $dados = vm.$dados
  var $route = vm.$route
  var params = $route.params
  var $requests = vm.$requests
  params.idaluno = (params.idaluno || 0) * 1
  params.idmatricula = (params.idmatricula || 0) * 1
  params.idbloco = (params.idbloco || 0) * 1
  var outroAluno = params.idaluno && (params.idaluno !== vm.$auth.user.id) && (vm.$auth.user.role !== 'admin')
  if (outroAluno) {
    location.hash = vm.$auth.user.id ? '#/aluno/' + vm.$auth.user.id : '#/'
    return
  }

  if (params.idaluno) {
    getCursos()
  }

  if (params.idaluno) {
    getAluno()
    if (($dados.MATRICULAS.length === 0) || ($dados.MATRICULAS[0].IDALUNO !== params.idaluno)) {
      getMatriculas().then(() => {
        if (params.idmatricula && (params.idmatricula !== $dados.MATRICULA.ID)) {
          getMatriculaCursoBlocos().then(() => {
            getBloco()
          })
        }
      })
    } else if (params.idmatricula && (params.idmatricula !== $dados.MATRICULA.ID)) {
      getMatriculaCursoBlocos().then(() => {
        getBloco()
      })
    } else if (params.idbloco && (params.idbloco !== $dados.BLOCOS.ID)) {
      getBloco()
    }
  }

  if (['COMPLETE', 'ASSERTIVAS', 'QUESTOES'].indexOf($route.name) >= 0) {
    getRodadas()
  }

  if (['COMPLETE-PERGUNTA', 'ASSERTIVAS-PERGUNTA', 'QUESTOES-PERGUNTA'].indexOf($route.name) >= 0) {
    getRodadas().then(() => {
      getPergunta()
    })
  }

  if (['APOSTILA', 'ASSUNTOS', 'DISPOSITIVOSLEGAIS'].indexOf($route.name) >= 0) {
    getApostilaAssuntos()
  }

  function getApostilaAssuntos () {
    var promise = $requests.get([
      '/SATACS/ALUNO',
      $route.params.idaluno,
      'MATRICULAS',
      $route.params.idmatricula,
      $route.name,
      $route.params.idbloco
    ].join('/'))
    promise.then(response => {
      var dados = {}
      dados[$route.name] = response.data.record || { records: [] }
      $dados.set(dados)
    })
    return promise
  }

  function getMatriculas () {
    var promise = $requests.get(['/SATACS/ALUNO', params.idaluno, 'MATRICULAS'].join('/'))
    promise.then(response => {
      $dados.set({
        MATRICULAS: response.data.records || []
      })
    })
    return promise
  }

  function getMatriculaCursoBlocos () {
    var promise = $requests.get([
      '/SATACS/ALUNO',
      $route.params.idaluno,
      'MATRICULAS',
      $route.params.idmatricula,
      'BLOCOS'
    ].join('/'))
    promise.then(response => {
      $dados.set({
        BLOCOS: response.data.record.BLOCOS
      })
    })
    $dados.MATRICULAS.forEach(MATRICULA => {
      if (params.idmatricula === MATRICULA.ID) {
        $dados.set({
          MATRICULA: MATRICULA
        })
        $dados.set({
          CURSO: {
            ID: MATRICULA.IDCURSO,
            NOME: MATRICULA.CURSO
          }
        })
      }
    })
    return promise
  }

  function getBloco () {
    $dados.set({
      BLOCO: {}
    })
    $dados.BLOCOS.forEach(BLOCO => {
      if (params.idbloco === BLOCO.ID) {
        $dados.set({
          BLOCO: BLOCO
        })
      }
    })
  }

  function getPergunta () {
    var endpoint = [
      '/SATACS/ALUNO',
      $route.params.idaluno,
      'MATRICULA',
      $route.params.idmatricula,
      $route.name.split('-').join('/'),
      'BLOCO',
      $route.params.idbloco,
      'RODADA',
      $route.params.rodada
    ].join('/')
    var promise = $requests.get(endpoint)
    promise.then(response => {
      $dados.set({
        RESPONDIDA: false,
        RESPOSTA: 0,
        PERGUNTA: response.data.record || {}
      })
    })
    return promise
  }

  getRodada(1)
  function getRodadas () {
    var name = $route.name.split('-')[0]
    var promise = $requests.get([
      '/SATACS/ALUNO',
      $route.params.idaluno,
      'MATRICULA',
      $route.params.idmatricula,
      name,
      'RODADAS',
      $route.params.idbloco
    ].join('/'))
    promise.then(response => {
      var record = response.data.record || {}
      var rodadas = record.RODADAS || []
      rodadas.sort(function (a, b) {
        return b.RODADA - a.RODADA
      })
      $dados.set({
        RODADAS: rodadas
      })
      getRodada(2)
    })
    return promise
  }

  function getCursos () {
    var promise = $requests.get([
      '/SATACS/ALUNO',
      $route.params.idaluno,
      'CURSOS'
    ].join('/'))
    promise.then(response => {
      $dados.set({
        CURSOS: response.data.records || []
      })
    })
    return promise
  }

  function getRodada (i) {
    var rodada = $route.params.rodada * 1
    var RODADA = {}
    if (rodada) {
      for (var index = 0; index < $dados.RODADAS.length; ++index) {
        var temp = $dados.RODADAS[index]
        if (temp.RODADA === rodada) {
          RODADA = temp
          break
        }
      }
    }
    $dados.set({
      RODADA: RODADA
    })
  }

  function getAluno () {
    var promise = $requests.get([
      '/ALUNOS',
      $route.params.idaluno
    ].join('/'))
    promise.then(response => {
      $dados.set({
        ALUNO: response.data.record || {}
      })
    })
  }
}
